$(document).ready(function() {
  $('select:not(.form-control-course)').material_select();

  $('.init-floatinglabels .input-field [placeholder]').removeAttr('placeholder');
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/form/index.js
 **/